import { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Button
} from "react-bootstrap";
import { MESSAGE } from "../../../utils/message";
import BadgeCheckBox from "../badgeCheckBox";
import ScriptCodeBox from "../scriptCodeBox";
import {
  DownloadReviewMain,
  DownloadReviewBox,
  BoxTitle,
  BoxText,
  BadgeWebsiteWrap,
  BadgeWebsiteTitle,
  BadgeWebsiteText,
  DownloadScriptCodeWrap,
  MiniBadgeSection,
  MiniBadgeTitle,
  MiniBadgeText,
  MiniBadgeWrap,
  MiniBadgeCodeCopyBox,
  SectionTitle,
  Title,
} from "./showOffYourReviewsStyle";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { nonprofitProfileHandler } from "../../../redux/slices/myNonprofit/nonprofitProfile-slice";

const ShowOffYourReviews = () => {
  const { id } = useParams()
  const [color, setColor] = useState<string | number>(1);
  const nonProfitData = useSelector((state: any) => state?.nonprofitProfile?.data?.results)
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(nonprofitProfileHandler(id) as any);
  }, [id]);
  const miniBadgeData = {
    id: 5,
    url: `https://greatnonprofits.org/badge/reviews_1_new/${nonProfitData?.title}`,
    script: `<script type="text/javascript">
     gnp_url = '${nonProfitData?.title}';gnp_num = '1';
</script>
<script src="https://new.greatnonprofits.org/js/api/badge_reviews.js" type="text/
javascript"></script>
<noscript> <a href="https://new.greatnonprofits.org/org/${nonProfitData?.title}/?badge=1"> <img
 alt="Review ${nonProfitData?.title} on Great Nonprofits" title="Review ${nonProfitData?.title} on Great 
 Nonprofits" src="//cdn.greatnonprofits.org/images/great-nonprofits.gif?id=${id}"> </a
 ></noscript>`,
  };

  const downloadReviews = () => {
    const content = "All reviews will listed here";
    const element = document.createElement("a");
    const file = new Blob([content], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = "flyer_template.csv";
    document.body.appendChild(element);
    element.click();
  };
  return (
    <>
      <SectionTitle>
        <Title>{MESSAGE.showOffYourReviews}</Title>
      </SectionTitle>
      <DownloadReviewMain>
        <DownloadReviewBox>
          <BoxTitle>{MESSAGE.downloadYourReviewArchive}</BoxTitle>
          <BoxText>
            Use your reviews in your nonprofit's marketing and website.
          </BoxText>
          <Button
            className="btn-outline-success-blue"
            onClick={downloadReviews}
          >
            Download Reviews
          </Button>
        </DownloadReviewBox>

        <BadgeWebsiteWrap>
          <BadgeWebsiteTitle>{MESSAGE.addLogoBadgeWebsite}</BadgeWebsiteTitle>
          <BadgeWebsiteText>
            Copy one of the code snippets below, then paste the code into your
            website wherever you would like your rating badge to appear.
          </BadgeWebsiteText>
          <BadgeCheckBox setColor={setColor} />
        </BadgeWebsiteWrap>
      </DownloadReviewMain>

      <DownloadScriptCodeWrap>
        <ScriptCodeBox color={color} />
      </DownloadScriptCodeWrap>

      <MiniBadgeSection>
        <MiniBadgeTitle>{MESSAGE.addReviewBadgeWebsite}</MiniBadgeTitle>
        <MiniBadgeText>
          Copy one of the code snippets below, then paste the code into your
          website wherever you would like your badge to appear.
        </MiniBadgeText>

        <MiniBadgeTitle>{MESSAGE.miniBadge}</MiniBadgeTitle>

        <MiniBadgeWrap>
          <iframe
            className="mini_badge-iframe"
            src={miniBadgeData?.url}
            title="mini_badge"
            width="240"
            height="460"
          ></iframe>
          <MiniBadgeCodeCopyBox><pre>{miniBadgeData?.script}</pre></MiniBadgeCodeCopyBox>
        </MiniBadgeWrap>
      </MiniBadgeSection>
    </>
  );
};

export default ShowOffYourReviews;
